import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';

const LoaderTextSkeleton = ({ numRows, rowHeight }) => {
  return Array.from({ length: numRows })
    .fill('')
    .map((it, i) => {
      const width = i % 2 === 0 ? '100%' : '95%';

      return (
        <Placeholder
          type="text"
          key={`row-${i}`}
          height={rowHeight}
          width={width}
          className="p2p-skeleton__text"
        />
      );
    });
};

LoaderTextSkeleton.propTypes = {
  numRows: PropTypes.number,
  rowHeight: PropTypes.string
};

LoaderTextSkeleton.defaultProps = {
  numRows: 4,
  rowHeight: '16px'
};

export default LoaderTextSkeleton;
